import React from 'react';
import { ArrowLeft, MapPin, Clock, ShieldCheck, Navigation } from 'lucide-react';
import { Link } from 'react-router-dom';
import NearbyAreas from './NearbyAreas';
import AreaDedicatedArticle from '../AreaDedicatedArticle';
import AreaRelatedArticles from '../AreaRelatedArticles';

const MajorDistrictTemplate = ({ areaData, displayName, phone, brand, images }) => {
  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1rem' }}>
      {/* Header Section */}
      <header id="header" className="area-hero-header" style={{
        background: 'linear-gradient(135deg, #0a2c61 0%, #1976d2 100%)',
        color: 'white',
        borderRadius: '1.5rem',
        padding: '3rem 2rem',
        marginBottom: '2rem',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
        marginTop: '2rem'
      }}>
        <div style={{
          position: 'absolute', top: '1rem', right: '1rem',
          background: '#ffc107', color: '#0a2c61', fontWeight: 900,
          fontSize: '1rem', borderRadius: '1rem', padding: '0.3rem 1rem'
        }}>
          خدمة 24/7
        </div>
        <nav aria-label="الرجوع إلى قائمة المناطق">
          <Link to="/areas" style={{
            position: 'absolute', top: '1rem', left: '1rem', color: 'white',
            textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '0.5rem',
            fontSize: '1rem', fontWeight: 600
          }}>
            <ArrowLeft size={20} /> المناطق
          </Link>
        </nav>
        <nav aria-label="مسار التنقل" style={{ fontSize: '0.95rem', marginBottom: '1rem', opacity: 0.95, direction: 'rtl', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
          <Link to="/" style={{ color: '#ffc107', textDecoration: 'none', fontWeight: 700 }}>الرئيسية</Link>
          <span style={{ color: 'rgba(255,255,255,0.7)' }}>/</span>
          <Link to="/areas" style={{ color: '#ffc107', textDecoration: 'none', fontWeight: 700 }}>مناطق الخدمة</Link>
          <span style={{ color: 'rgba(255,255,255,0.7)' }}>/</span>
          <span style={{ color: '#ffffff', fontWeight: 800 }}>ونش انقاذ {displayName}</span>
        </nav>
        <h1 style={{ fontSize: '2.5rem', fontWeight: 900, marginBottom: '1rem', direction: 'rtl' }}>
          ونش انقاذ {displayName} | خصم 50%
        </h1>
        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
          background: 'rgba(255,255,255,0.2)', padding: '0.5rem 1.2rem',
          borderRadius: '2rem', fontSize: '1.1rem', fontWeight: 700,
          marginBottom: '1rem', direction: 'rtl'
        }}>
          <Clock size={20} color="#ffc107" />
          <span>وقت الاستجابة: {areaData.responseTime}</span>
        </div>
        <p style={{ fontSize: '1.2rem', opacity: 0.95, maxWidth: '750px', margin: '0 auto 1rem auto', direction: 'rtl', lineHeight: 1.8 }}>
          {areaData.intro}
        </p>
      </header>

      {/* Pricing Table (Unique to Major Districts) */}
      <section id="pricing" aria-labelledby="pricing-heading" style={{ background: 'white', borderRadius: '1.5rem', padding: '2rem', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', marginBottom: '2rem', border: '2px solid #e3f0ff', direction: 'rtl' }}>
        <h2 id="pricing-heading" style={{ fontSize: '1.5rem', fontWeight: 800, color: '#0a2c61', marginBottom: '1.5rem', textAlign: 'center' }}>
          جدول أسعار الإنقاذ التقريبية في {displayName}
        </h2>
        <table aria-labelledby="pricing-heading" style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'right' }}>
          <thead>
            <tr style={{ background: '#0077ff', color: 'white' }}>
              <th scope="col" style={{ padding: '1rem', border: '1px solid #ddd' }}>نوع الخدمة</th>
              <th scope="col" style={{ padding: '1rem', border: '1px solid #ddd' }}>السعر التقديري</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ padding: '1rem', border: '1px solid #ddd' }}>سحب سيارة ملاكي داخل {displayName}</td>
              <td style={{ padding: '1rem', border: '1px solid #ddd' }}>يبدأ من 250 ج.م</td>
            </tr>
            <tr>
              <td style={{ padding: '1rem', border: '1px solid #ddd' }}>إنقاذ من الطرق السريعة المجاورة</td>
              <td style={{ padding: '1rem', border: '1px solid #ddd' }}>يبدأ من 350 ج.م</td>
            </tr>
          </tbody>
        </table>
      </section>

      {/* Dispatch Points Section */}
      {areaData.dispatchPoints && areaData.dispatchPoints.length > 0 && (
        <section id="dispatch-points" aria-labelledby="dispatch-heading" style={{
          background: 'white', borderRadius: '1.5rem', padding: '2rem',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)', marginBottom: '2rem',
          border: '2px solid #e3f0ff', direction: 'rtl'
        }}>
          <h2 id="dispatch-heading" style={{ fontSize: '1.5rem', fontWeight: 800, color: '#0a2c61', marginBottom: '1.5rem', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
            <Navigation size={24} color="#0077ff" /> نقاط وتمركزات أوناشنا الميدانية في {displayName}
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '1rem' }}>
            {areaData.dispatchPoints.map((dp, i) => (
              <div key={i} style={{ background: '#f0f7ff', border: '1px solid #cce3ff', borderRadius: '1rem', padding: '1rem', display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
                <div style={{ width: '12px', height: '12px', borderRadius: '50%', background: '#0077ff', flexShrink: 0 }}></div>
                <span style={{ fontSize: '1.05rem', fontWeight: 700, color: '#0a2c61' }}>{dp}</span>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* Local Coverage Section */}
      <section id="local-coverage" aria-labelledby="coverage-heading" style={{ background: 'white', borderRadius: '1.5rem', padding: '2rem', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', marginBottom: '2rem', border: '2px solid #e3f0ff', direction: 'rtl' }}>
        <h2 id="coverage-heading" style={{ fontSize: '1.5rem', fontWeight: 800, color: '#0a2c61', marginBottom: '1.5rem', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
          <MapPin size={24} color="#0077ff" /> المحاور والمعالم في {displayName}
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem' }}>
          <article style={{ background: '#f8f9fa', padding: '1.2rem', borderRadius: '1rem', border: '1px solid #e9ecef' }}>
            <h3 style={{ fontSize: '1.15rem', fontWeight: 700, color: '#0077ff', marginBottom: '0.8rem' }}>المعالم والتقاطعات الحيوية:</h3>
            <ul style={{ paddingRight: '1.2rem', margin: 0, lineHeight: 1.8 }}>
              {areaData.landmarks.map((lm, i) => <li key={i} style={{ marginBottom: '0.4rem' }}>{lm}</li>)}
            </ul>
          </article>
          <article style={{ background: '#f8f9fa', padding: '1.2rem', borderRadius: '1rem', border: '1px solid #e9ecef' }}>
            <h3 style={{ fontSize: '1.15rem', fontWeight: 700, color: '#0077ff', marginBottom: '0.8rem' }}>الشوارع الرئيسية:</h3>
            <ul style={{ paddingRight: '1.2rem', margin: 0, lineHeight: 1.8 }}>
              {areaData.streets.map((st, i) => <li key={i} style={{ marginBottom: '0.4rem' }}>{st}</li>)}
            </ul>
          </article>
        </div>

        {/* Local Notes (Story-Mode Egyptian Content) */}
        {areaData.localNotes && areaData.localNotes.length > 0 && (
          <aside aria-label={`إرشادات وملاحظات الإنقاذ في ${displayName}`} style={{
            background: '#e3f0ff', padding: '1.2rem', borderRadius: '1rem',
            border: '1px solid #0077ff', marginTop: '1.5rem', direction: 'rtl'
          }}>
            <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#0a2c61', marginBottom: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
              <ShieldCheck size={20} color="#0077ff" />
              إرشادات وملاحظات الإنقاذ في {displayName}:
            </h3>
            {areaData.localNotes.map((note, i) => (
              <p key={i} style={{ margin: '0.4rem 0', fontSize: '1.05rem', color: '#0a2c61', lineHeight: 1.7 }}>• {note}</p>
            ))}
          </aside>
        )}
      </section>

      {/* Dedicated Supporting Article Section */}
      <AreaDedicatedArticle
        areaData={areaData}
        displayName={displayName}
        templateType="MajorDistrict"
        phone={phone}
      />

      {/* Related Supporting Articles & Pillar Guides */}
      <AreaRelatedArticles areaName={displayName} />

      {/* FAQ */}
      {areaData.faqs && areaData.faqs.length > 0 && (
        <section id="faq" aria-labelledby="faq-heading" style={{ background: 'white', borderRadius: '1.5rem', padding: '2rem', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', marginBottom: '2rem', border: '2px solid #e3f0ff', direction: 'rtl' }}>
          <h2 id="faq-heading" style={{ fontSize: '1.5rem', fontWeight: 800, color: '#0a2c61', marginBottom: '1.5rem', textAlign: 'center' }}>أسئلة شائعة حول الإنقاذ في {displayName}</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {areaData.faqs.map((faq, index) => (
              <article key={index} style={{ background: '#f8f9fa', border: '1px solid #e9ecef', borderRadius: '1rem', padding: '1.5rem' }}>
                <h3 style={{ fontSize: '1.2rem', fontWeight: 700, color: '#0077ff', marginBottom: '0.5rem' }}>{faq.q}</h3>
                <p style={{ margin: 0, color: '#333', lineHeight: 1.6 }}>{faq.a}</p>
              </article>
            ))}
          </div>
        </section>
      )}

      {/* Nearby Areas — Internal Linking */}
      <NearbyAreas nearby={areaData.nearby} accentColor="#0077ff" />
    </div>
  );
};
export default MajorDistrictTemplate;
